import { render, staticRenderFns } from "./CompanyAwayDetailEditForm.vue?vue&type=template&id=851c7244&scoped=true&"
import script from "./CompanyAwayDetailEditForm.vue?vue&type=script&lang=js&"
export * from "./CompanyAwayDetailEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851c7244",
  null
  
)

export default component.exports